import { createContext, useContext, useEffect, useState } from 'react'
import { client } from '@/services/sanityClient'

const QUERY = `*[_type == "siteSettings"][0]{
  phones, email, address, workingHours, workingHoursWeekend, telegram, viber, facebook
}`

const defaults = {
  phones: ['+38 (097) 123-45-67'],
  phone: '+38 (097) 123-45-67',
  email: 'info@kameniar.ua',
  address: 'м. Ямпіль, вул. Молодіжна',
  workingHours: 'Пн–Пт: 09:00–18:00',
  workingHoursWeekend: 'Сб: 10:00–15:00',
  telegram: 'https://t.me/yourchannel',
  viber: '380971234567',
  facebook: 'https://facebook.com',
}

const SiteSettingsContext = createContext(defaults)

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(defaults)

  useEffect(() => {
    client.fetch(QUERY).then((data) => {
      if (data) {
        const phones = data.phones?.length ? data.phones : defaults.phones
        setSettings({ ...defaults, ...data, phones, phone: phones[0] })
      }
    })
  }, [])

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  )
}

export const useSiteSettings = () => useContext(SiteSettingsContext)
